import { SelectionModel } from "@angular/cdk/collections";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import {
  MatDialogRef,
  MatDialog,
  MatDialogConfig,
} from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Subject, Subscription } from "rxjs";
import { DepartmentsService } from "src/app/admin/data/services/departments.service";

import { SnackbarService } from "src/app/shared/services/snackbar.service";

import { FamilyMembersComponent } from "../family-members/family-members.component";
import { AddAccountComponent } from "../../users/pages/add-account/add-account.component";
import { AccountService } from "../../users/data/services/account.service";


@Component({
  selector: "app-location-lookup",
  templateUrl: "./location-lookup.component.html",
  styleUrls: ["./location-lookup.component.sass"],
})
export class LocationLookupComponent implements OnInit {
  displayedColumns: string[] = [
    "select",
    "id",
    "county",
    "con",
    "ward",
    "village",
  ];

  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  contextMenu: MatMenuTrigger;
  subscription!: Subscription;
  selection = new SelectionModel<any>(true, []);
  location: any[] = [];
  error: any;

  formData: any;

  isLoading = true;

  locationDetails: any;
  selectedRows: any[] = [];
  atleastOneSelected: boolean = false;

  dataSourceFilteredList: any[] = [];
  locationArray: any[] = [];

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public dialogRef: MatDialogRef<AddAccountComponent>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private snackbar: SnackbarService,
    private accountService: AccountService,
    private deptService: DepartmentsService
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  filter() {
    //let storeId = [1, 2, 3];
    this.dataSource.data.forEach((element) => {
      this.locationArray.forEach((item) => {
        if (item === element.id) {
          this.selection.select(element);
        }
      });
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.position + 1
    }`;
  }

  expSelected() {
    this.atleastOneSelected = true;
    this.selectedRows = this.selection.selected;
  }
  proceed() {
    this.dialogRef.close({ event: "close", data: this.selectedRows });

    //   console.log(data);
  }

  onNoClick(): void {
    this.dialogRef.close({ event: "close", data: this.selectedRows });
  }
  public confirmAdd(): void {}

  getData() {
    this.accountService.location().subscribe((res) => {
      this.location = res.entity;

      if (this.location) {
        this.isLoading = false;
      }

      this.dataSource = new MatTableDataSource(this.location);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  selectedLocation: any[] = [];
}
